import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57ba709f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4 is-flex is-justify-content-space-between is-align-items-center gap-2" }
const _hoisted_3 = { class: "is-flex is-align-items-center gap-2" }
const _hoisted_4 = { class: "title is-size-4 mb-0" }
const _hoisted_5 = { class: "is-flex is-align-items-center gap-1" }
const _hoisted_6 = { class: "table is-narrow is-bordered is-striped is-fullwidth" }
const _hoisted_7 = { class: "has-background-light" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " Name ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " Identifiers ", -1))
const _hoisted_10 = { class: "has-text-right" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_21 = {
  key: 0,
  class: "tag is-warning is-light"
}
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { class: "is-flex gap-4" }
const _hoisted_24 = { class: "is-flex is-align-items-center gap-1" }
const _hoisted_25 = { class: "pr-1" }
const _hoisted_26 = ["native-value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tagged_literal = _resolveComponent("tagged-literal")!
  const _component_shared_dimension_tags = _resolveComponent("shared-dimension-tags")!
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_download_button = _resolveComponent("download-button")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_b_message = _resolveComponent("b-message")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_term_display = _resolveComponent("term-display")!
  const _component_external_term_link = _resolveComponent("external-term-link")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page_content = _resolveComponent("page-content")!

  return (_openBlock(), _createBlock(_component_page_content, { class: "container-narrow" }, {
    default: _withCtx(() => [
      (_ctx.dimension)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, [
                  _createVNode(_component_tagged_literal, { ".resource": _ctx.dimension }, null, 8, [".resource"])
                ]),
                _createVNode(_component_shared_dimension_tags, { dimension: _ctx.dimension }, null, 8, ["dimension"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_hydra_operation_button, {
                  operation: _ctx.dimension.actions.replace,
                  to: { name: 'SharedDimensionEdit' }
                }, null, 8, ["operation"]),
                _createVNode(_component_hydra_operation_button, {
                  operation: _ctx.dimension.actions.delete,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteDimension(_ctx.dimension)))
                }, null, 8, ["operation"]),
                _createVNode(_component_download_button, {
                  resource: _ctx.dimension.export,
                  size: "small",
                  variant: "white"
                }, null, 8, ["resource"])
              ])
            ]),
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("td", _hoisted_10, [
                    (_ctx.dimension.actions.create)
                      ? (_openBlock(), _createBlock(_component_hydra_operation_button, {
                          key: 0,
                          operation: _ctx.dimension.actions.create,
                          to: { name: 'SharedDimensionTermCreate' },
                          variant: "default",
                          label: _ctx.dimension.actions.create.title
                        }, null, 8, ["operation", "label"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.terms.isLoading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                      _createElementVNode("td", {
                        colspan: _ctx.tableWidth,
                        class: "p-0"
                      }, [
                        _createVNode(_component_loading_block, {
                          class: "has-background-light is-size-2",
                          style: _normalizeStyle(`height: calc(38px * ${_ctx.pageSize});`)
                        }, null, 8, ["style"])
                      ], 8, _hoisted_12)
                    ]))
                  : (_ctx.terms.error)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _createElementVNode("td", { colspan: _ctx.tableWidth }, [
                          _createVNode(_component_b_message, { type: "is-danger" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.terms.error), 1)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_14)
                      ]))
                    : (_ctx.terms.data.length === 0 && _ctx.page === 1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("td", { colspan: _ctx.tableWidth }, [
                            _createTextVNode(" Nothing in this dimension yet. "),
                            (_ctx.dimension.actions.create)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                  _createTextVNode(" Do you want to "),
                                  _createVNode(_component_router_link, { to: { name: 'SharedDimensionTermCreate' } }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" add a term ")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("? ")
                                ]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_16)
                        ]))
                      : (_ctx.terms.data.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                            _createElementVNode("td", { colspan: _ctx.tableWidth }, " You reached the end of terms ", 8, _hoisted_19)
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.terms.data, (term) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: term.clientPath,
                              class: _normalizeClass({ 'has-background-success-light': term.newlyCreated })
                            }, [
                              _createElementVNode("td", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(term.name, (name, index) => {
                                  return (_openBlock(), _createElementBlock("p", { key: index }, [
                                    (_openBlock(), _createBlock(_component_term_display, {
                                      key: name.value,
                                      term: name,
                                      "show-language": true
                                    }, null, 8, ["term"]))
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("td", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(term.identifiers, (identifier, index) => {
                                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(identifier), 1))
                                }), 128))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", null, [
                                    (term.validThrough <= new Date())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, " deprecated "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_external_term_link, { term: term }, null, 8, ["term"]),
                                    _createVNode(_component_hydra_operation_button, {
                                      operation: term.actions.replace,
                                      to: { name: 'SharedDimensionTermEdit', params: { termId: term.clientPath } }
                                    }, null, 8, ["operation", "to"]),
                                    _createVNode(_component_hydra_operation_button, {
                                      operation: term.actions.delete,
                                      onClick: ($event: any) => (_ctx.deleteTerm(term))
                                    }, null, 8, ["operation", "onClick"])
                                  ])
                                ])
                              ])
                            ], 2))
                          }), 128))
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableWidth,
                    class: "has-background-light"
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, "Page " + _toDisplayString(_ctx.page), 1),
                        _createVNode(_component_o_tooltip, { label: "Previous page" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_button, {
                              "icon-left": "chevron-left",
                              onClick: _ctx.prevPage,
                              disabled: !_ctx.terms.data || _ctx.page === 1
                            }, null, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_o_tooltip, { label: "Next page" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_button, {
                              "icon-left": "chevron-right",
                              onClick: _ctx.nextPage,
                              disabled: !_ctx.terms.data || _ctx.terms.data.length === 0
                            }, null, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_o_tooltip, { label: "Page size" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_select, {
                            "model-value": _ctx.pageSize,
                            "onUpdate:modelValue": _ctx.changePageSize,
                            title: "Page size"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSizes, (pageSizeOption) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: pageSizeOption,
                                  "native-value": pageSizeOption
                                }, _toDisplayString(pageSizeOption), 9, _hoisted_26))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 8, _hoisted_22)
                ])
              ])
            ]),
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
    ]),
    _: 1
  }))
}